// source: exSymbols.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

goog.exportSymbol('proto.common.model.ExSymbols', null, global);
goog.exportSymbol('proto.common.model.ExSymbols.Data', null, global);
goog.exportSymbol('proto.common.model.ExSymbols.FullData', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.common.model.ExSymbols = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.common.model.ExSymbols.repeatedFields_, null);
};
goog.inherits(proto.common.model.ExSymbols, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.common.model.ExSymbols.displayName = 'proto.common.model.ExSymbols';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.common.model.ExSymbols.Data = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.common.model.ExSymbols.Data, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.common.model.ExSymbols.Data.displayName = 'proto.common.model.ExSymbols.Data';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.common.model.ExSymbols.FullData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.common.model.ExSymbols.FullData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.common.model.ExSymbols.FullData.displayName = 'proto.common.model.ExSymbols.FullData';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.common.model.ExSymbols.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.common.model.ExSymbols.prototype.toObject = function(opt_includeInstance) {
  return proto.common.model.ExSymbols.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.common.model.ExSymbols} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.model.ExSymbols.toObject = function(includeInstance, msg) {
  var f, obj = {
exchange: jspb.Message.getFieldWithDefault(msg, 1, 0),
dataList: jspb.Message.toObjectList(msg.getDataList(),
    proto.common.model.ExSymbols.Data.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.common.model.ExSymbols}
 */
proto.common.model.ExSymbols.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.common.model.ExSymbols;
  return proto.common.model.ExSymbols.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.common.model.ExSymbols} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.common.model.ExSymbols}
 */
proto.common.model.ExSymbols.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setExchange(value);
      break;
    case 2:
      var value = new proto.common.model.ExSymbols.Data;
      reader.readMessage(value,proto.common.model.ExSymbols.Data.deserializeBinaryFromReader);
      msg.addData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.common.model.ExSymbols.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.common.model.ExSymbols.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.common.model.ExSymbols} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.model.ExSymbols.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExchange();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.common.model.ExSymbols.Data.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.common.model.ExSymbols.Data.prototype.toObject = function(opt_includeInstance) {
  return proto.common.model.ExSymbols.Data.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.common.model.ExSymbols.Data} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.model.ExSymbols.Data.toObject = function(includeInstance, msg) {
  var f, obj = {
symbol: jspb.Message.getFieldWithDefault(msg, 1, ""),
basecurrency: jspb.Message.getFieldWithDefault(msg, 2, ""),
quotecurrency: jspb.Message.getFieldWithDefault(msg, 3, ""),
baseincrement: jspb.Message.getFieldWithDefault(msg, 4, ""),
quoteincrement: jspb.Message.getFieldWithDefault(msg, 5, ""),
priceincrement: jspb.Message.getFieldWithDefault(msg, 6, ""),
baseprecision: jspb.Message.getFieldWithDefault(msg, 7, 0),
quoteprecision: jspb.Message.getFieldWithDefault(msg, 8, 0),
priceprecision: jspb.Message.getFieldWithDefault(msg, 9, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.common.model.ExSymbols.Data}
 */
proto.common.model.ExSymbols.Data.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.common.model.ExSymbols.Data;
  return proto.common.model.ExSymbols.Data.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.common.model.ExSymbols.Data} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.common.model.ExSymbols.Data}
 */
proto.common.model.ExSymbols.Data.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setBasecurrency(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuotecurrency(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setBaseincrement(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuoteincrement(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setPriceincrement(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setBaseprecision(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQuoteprecision(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPriceprecision(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.common.model.ExSymbols.Data.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.common.model.ExSymbols.Data.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.common.model.ExSymbols.Data} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.model.ExSymbols.Data.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBasecurrency();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getQuotecurrency();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getBaseincrement();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getQuoteincrement();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getPriceincrement();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getBaseprecision();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getQuoteprecision();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getPriceprecision();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
};


/**
 * optional string symbol = 1;
 * @return {string}
 */
proto.common.model.ExSymbols.Data.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExSymbols.Data} returns this
 */
proto.common.model.ExSymbols.Data.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string baseCurrency = 2;
 * @return {string}
 */
proto.common.model.ExSymbols.Data.prototype.getBasecurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExSymbols.Data} returns this
 */
proto.common.model.ExSymbols.Data.prototype.setBasecurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string quoteCurrency = 3;
 * @return {string}
 */
proto.common.model.ExSymbols.Data.prototype.getQuotecurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExSymbols.Data} returns this
 */
proto.common.model.ExSymbols.Data.prototype.setQuotecurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string baseIncrement = 4;
 * @return {string}
 */
proto.common.model.ExSymbols.Data.prototype.getBaseincrement = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExSymbols.Data} returns this
 */
proto.common.model.ExSymbols.Data.prototype.setBaseincrement = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string quoteIncrement = 5;
 * @return {string}
 */
proto.common.model.ExSymbols.Data.prototype.getQuoteincrement = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExSymbols.Data} returns this
 */
proto.common.model.ExSymbols.Data.prototype.setQuoteincrement = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string priceIncrement = 6;
 * @return {string}
 */
proto.common.model.ExSymbols.Data.prototype.getPriceincrement = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExSymbols.Data} returns this
 */
proto.common.model.ExSymbols.Data.prototype.setPriceincrement = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional int32 basePrecision = 7;
 * @return {number}
 */
proto.common.model.ExSymbols.Data.prototype.getBaseprecision = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.common.model.ExSymbols.Data} returns this
 */
proto.common.model.ExSymbols.Data.prototype.setBaseprecision = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int32 quotePrecision = 8;
 * @return {number}
 */
proto.common.model.ExSymbols.Data.prototype.getQuoteprecision = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.common.model.ExSymbols.Data} returns this
 */
proto.common.model.ExSymbols.Data.prototype.setQuoteprecision = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int32 pricePrecision = 9;
 * @return {number}
 */
proto.common.model.ExSymbols.Data.prototype.getPriceprecision = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.common.model.ExSymbols.Data} returns this
 */
proto.common.model.ExSymbols.Data.prototype.setPriceprecision = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.common.model.ExSymbols.FullData.prototype.toObject = function(opt_includeInstance) {
  return proto.common.model.ExSymbols.FullData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.common.model.ExSymbols.FullData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.model.ExSymbols.FullData.toObject = function(includeInstance, msg) {
  var f, obj = {
symbol: jspb.Message.getFieldWithDefault(msg, 1, ""),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
basecurrency: jspb.Message.getFieldWithDefault(msg, 3, ""),
quotecurrency: jspb.Message.getFieldWithDefault(msg, 4, ""),
baseminsize: jspb.Message.getFieldWithDefault(msg, 5, ""),
quoteminsize: jspb.Message.getFieldWithDefault(msg, 6, ""),
basemaxsize: jspb.Message.getFieldWithDefault(msg, 7, ""),
quotemaxsize: jspb.Message.getFieldWithDefault(msg, 8, ""),
baseincrement: jspb.Message.getFieldWithDefault(msg, 9, ""),
quoteincrement: jspb.Message.getFieldWithDefault(msg, 10, ""),
priceincrement: jspb.Message.getFieldWithDefault(msg, 11, ""),
feecurrency: jspb.Message.getFieldWithDefault(msg, 12, ""),
enabletrading: jspb.Message.getBooleanFieldWithDefault(msg, 13, false),
ismarginenable: jspb.Message.getBooleanFieldWithDefault(msg, 14, false),
pricelimitrate: jspb.Message.getFieldWithDefault(msg, 15, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.common.model.ExSymbols.FullData}
 */
proto.common.model.ExSymbols.FullData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.common.model.ExSymbols.FullData;
  return proto.common.model.ExSymbols.FullData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.common.model.ExSymbols.FullData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.common.model.ExSymbols.FullData}
 */
proto.common.model.ExSymbols.FullData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setBasecurrency(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuotecurrency(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setBaseminsize(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuoteminsize(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setBasemaxsize(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuotemaxsize(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setBaseincrement(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuoteincrement(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setPriceincrement(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setFeecurrency(value);
      break;
    case 13:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnabletrading(value);
      break;
    case 14:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsmarginenable(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setPricelimitrate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.common.model.ExSymbols.FullData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.common.model.ExSymbols.FullData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.common.model.ExSymbols.FullData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.model.ExSymbols.FullData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getBasecurrency();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getQuotecurrency();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getBaseminsize();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getQuoteminsize();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getBasemaxsize();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getQuotemaxsize();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getBaseincrement();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getQuoteincrement();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getPriceincrement();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getFeecurrency();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getEnabletrading();
  if (f) {
    writer.writeBool(
      13,
      f
    );
  }
  f = message.getIsmarginenable();
  if (f) {
    writer.writeBool(
      14,
      f
    );
  }
  f = message.getPricelimitrate();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
};


/**
 * optional string symbol = 1;
 * @return {string}
 */
proto.common.model.ExSymbols.FullData.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExSymbols.FullData} returns this
 */
proto.common.model.ExSymbols.FullData.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.common.model.ExSymbols.FullData.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExSymbols.FullData} returns this
 */
proto.common.model.ExSymbols.FullData.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string baseCurrency = 3;
 * @return {string}
 */
proto.common.model.ExSymbols.FullData.prototype.getBasecurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExSymbols.FullData} returns this
 */
proto.common.model.ExSymbols.FullData.prototype.setBasecurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string quoteCurrency = 4;
 * @return {string}
 */
proto.common.model.ExSymbols.FullData.prototype.getQuotecurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExSymbols.FullData} returns this
 */
proto.common.model.ExSymbols.FullData.prototype.setQuotecurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string baseMinSize = 5;
 * @return {string}
 */
proto.common.model.ExSymbols.FullData.prototype.getBaseminsize = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExSymbols.FullData} returns this
 */
proto.common.model.ExSymbols.FullData.prototype.setBaseminsize = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string quoteMinSize = 6;
 * @return {string}
 */
proto.common.model.ExSymbols.FullData.prototype.getQuoteminsize = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExSymbols.FullData} returns this
 */
proto.common.model.ExSymbols.FullData.prototype.setQuoteminsize = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string baseMaxSize = 7;
 * @return {string}
 */
proto.common.model.ExSymbols.FullData.prototype.getBasemaxsize = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExSymbols.FullData} returns this
 */
proto.common.model.ExSymbols.FullData.prototype.setBasemaxsize = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string quoteMaxSize = 8;
 * @return {string}
 */
proto.common.model.ExSymbols.FullData.prototype.getQuotemaxsize = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExSymbols.FullData} returns this
 */
proto.common.model.ExSymbols.FullData.prototype.setQuotemaxsize = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string baseIncrement = 9;
 * @return {string}
 */
proto.common.model.ExSymbols.FullData.prototype.getBaseincrement = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExSymbols.FullData} returns this
 */
proto.common.model.ExSymbols.FullData.prototype.setBaseincrement = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string quoteIncrement = 10;
 * @return {string}
 */
proto.common.model.ExSymbols.FullData.prototype.getQuoteincrement = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExSymbols.FullData} returns this
 */
proto.common.model.ExSymbols.FullData.prototype.setQuoteincrement = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string priceIncrement = 11;
 * @return {string}
 */
proto.common.model.ExSymbols.FullData.prototype.getPriceincrement = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExSymbols.FullData} returns this
 */
proto.common.model.ExSymbols.FullData.prototype.setPriceincrement = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string feeCurrency = 12;
 * @return {string}
 */
proto.common.model.ExSymbols.FullData.prototype.getFeecurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExSymbols.FullData} returns this
 */
proto.common.model.ExSymbols.FullData.prototype.setFeecurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional bool enableTrading = 13;
 * @return {boolean}
 */
proto.common.model.ExSymbols.FullData.prototype.getEnabletrading = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 13, false));
};


/**
 * @param {boolean} value
 * @return {!proto.common.model.ExSymbols.FullData} returns this
 */
proto.common.model.ExSymbols.FullData.prototype.setEnabletrading = function(value) {
  return jspb.Message.setProto3BooleanField(this, 13, value);
};


/**
 * optional bool isMarginEnable = 14;
 * @return {boolean}
 */
proto.common.model.ExSymbols.FullData.prototype.getIsmarginenable = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 14, false));
};


/**
 * @param {boolean} value
 * @return {!proto.common.model.ExSymbols.FullData} returns this
 */
proto.common.model.ExSymbols.FullData.prototype.setIsmarginenable = function(value) {
  return jspb.Message.setProto3BooleanField(this, 14, value);
};


/**
 * optional string priceLimitRate = 15;
 * @return {string}
 */
proto.common.model.ExSymbols.FullData.prototype.getPricelimitrate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExSymbols.FullData} returns this
 */
proto.common.model.ExSymbols.FullData.prototype.setPricelimitrate = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional int32 exchange = 1;
 * @return {number}
 */
proto.common.model.ExSymbols.prototype.getExchange = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.common.model.ExSymbols} returns this
 */
proto.common.model.ExSymbols.prototype.setExchange = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * repeated Data data = 2;
 * @return {!Array<!proto.common.model.ExSymbols.Data>}
 */
proto.common.model.ExSymbols.prototype.getDataList = function() {
  return /** @type{!Array<!proto.common.model.ExSymbols.Data>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.common.model.ExSymbols.Data, 2));
};


/**
 * @param {!Array<!proto.common.model.ExSymbols.Data>} value
 * @return {!proto.common.model.ExSymbols} returns this
*/
proto.common.model.ExSymbols.prototype.setDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.common.model.ExSymbols.Data=} opt_value
 * @param {number=} opt_index
 * @return {!proto.common.model.ExSymbols.Data}
 */
proto.common.model.ExSymbols.prototype.addData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.common.model.ExSymbols.Data, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.common.model.ExSymbols} returns this
 */
proto.common.model.ExSymbols.prototype.clearDataList = function() {
  return this.setDataList([]);
};


goog.object.extend(exports, proto.common.model);
